import {useEffect} from 'react';

// Đếm số lớp phủ đang mở. Cần đếm vì modal có thể lồng nhau (vd: lịch sử →
// biểu đồ phóng to); nếu mỗi modal tự "unset" khi đóng thì nền sẽ cuộn được
// trong khi modal ngoài vẫn đang mở.
let openCount = 0;
// Vị trí cuộn của trang lúc lớp phủ ĐẦU TIÊN mở ra - để trả lại đúng chỗ cũ.
let lockedScrollY = 0;

/**
 * Khoá cuộn trang nền khi có lớp phủ.
 *
 * VÌ SAO KHÔNG CHỈ `overflow: hidden` TRÊN BODY
 * ---------------------------------------------------------------------------
 * Trên iOS Safari, `overflow: hidden` không chặn được cú vuốt: ngón tay đặt lên
 * phần không cuộn được của lớp phủ (nền mờ, thanh tiêu đề, thanh nút ở đáy) vẫn
 * kéo cả trang nền trôi đi phía sau. Đóng lớp phủ ra thì trang đã ở một chỗ
 * khác - chủ nhà đang dò tới phòng 305 giữa danh sách, mở một hộp thoại, đóng
 * lại, và danh sách đã nhảy về đâu đó. Đó là một nửa của cảm giác "xộc xệch".
 *
 * Cách chắc chắn duy nhất là `position: fixed` cho body: trang nền mất khả năng
 * cuộn thật sự, chứ không phải chỉ bị bảo là đừng cuộn. Đổi lại phải tự nhớ và
 * trả lại vị trí cuộn, vì `position: fixed` kéo body về đầu trang - đó là việc
 * của `lockedScrollY` và cú `scrollTo` lúc mở khoá.
 *
 * `scroll-behavior: smooth` (index.css, chỉ còn trên máy tính) sẽ biến cú nhảy
 * về đó thành một pha trượt thấy rõ, nên tắt tạm trong đúng một nhịp.
 */
export const useBodyScrollLock = (isLocked: boolean) => {
    useEffect(() => {
        if (!isLocked) return;

        const {body} = document;
        const root = document.documentElement;

        openCount += 1;
        if (openCount === 1) {
            lockedScrollY = window.scrollY;
            body.style.position = 'fixed';
            body.style.top = `-${lockedScrollY}px`;
            body.style.left = '0';
            body.style.right = '0';
            body.style.overflow = 'hidden';
        }

        return () => {
            openCount = Math.max(0, openCount - 1);
            if (openCount > 0) return;

            body.style.position = '';
            body.style.top = '';
            body.style.left = '';
            body.style.right = '';
            body.style.overflow = '';

            const previousBehavior = root.style.scrollBehavior;
            root.style.scrollBehavior = 'auto';
            window.scrollTo(0, lockedScrollY);
            root.style.scrollBehavior = previousBehavior;
        };
    }, [isLocked]);
};
